import React from "react";

import magic from "@iconify/icons-bi/magic";
import { Icon } from "@iconify/react/dist/offline";

import { Button } from "src/components/ui/button";
import { useMagicLink } from "src/experiences/auth/hooks/useMagicLink";

interface MagicLinkProps {
  email: string;
}

export const MagicLinkButton = ({
  email,
}: MagicLinkProps): React.ReactElement => {
  const sendMagicLink = useMagicLink();

  return (
    <Button
      variant="outline"
      className="w-full"
      onClick={() => sendMagicLink(email)}
    >
      <Icon icon={magic} className="mr-2 h-4 w-4" />
      Send magic link
    </Button>
  );
};
